




















import { Component, Vue, Watch } from 'vue-property-decorator';
import {IProxyUserBansStatistics} from '@/interfaces';
import {
  dispatchGetProxyUserBansStatistics,
} from '@/store/admin/accessors';

@Component
export default class Statistics extends Vue {
  public loading: boolean = false;
  public statistics: IProxyUserBansStatistics[] = [];

  public headers = [
    {
      text: 'Service',
      value: 'service',
      align: 'left',
    },
    {
      text: 'Error',
      value: 'error',
      align: 'left',
    },
    {
      text: 'Count',
      value: 'count',
      align: 'left',
    },
  ];

  public updateProxyUserBans() {
    this.loading = true;
    this.getDataFromApi().then((data) => {
      if (data) {
        this.statistics = data;
      }
    });
    this.loading = false;
  }

  public async mounted() {
    this.updateProxyUserBans();
  }

  public async getDataFromApi() {
    return await dispatchGetProxyUserBansStatistics(this.$store);
  }

}
